import { render } from "./LoremWidget.vue?vue&type=template&id=7e304531&scoped=true"
import script from "./LoremWidget.vue?vue&type=script&lang=js"
export * from "./LoremWidget.vue?vue&type=script&lang=js"

import "./LoremWidget.vue?vue&type=style&index=0&id=7e304531&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e304531"]])

export default __exports__